import { gql, TypedDocumentNode } from "@apollo/client";

export type PbdSelectedPersonMembershipNode = {
  id: string;
  pgaId: string;
  latestProgram?: {
    programType?: { name?: string | null } | null;
    band?: {
      classification?: { name?: string | null; description?: string | null } | null;
    } | null;
  } | null;
};

export type PbdSelectedPeopleMembershipResponse = {
  people: { nodes: PbdSelectedPersonMembershipNode[] } | null;
};

export type PbdSelectedPeopleMembershipVariables = {
  input: { pgaIds: string[] };
  first: number;
};

export const PBD_SELECTED_PEOPLE_MEMBERSHIP_QUERY: TypedDocumentNode<
  PbdSelectedPeopleMembershipResponse,
  PbdSelectedPeopleMembershipVariables
> = gql`
  query PbdSelectedPeopleMembership($input: BackofficeCRMPeopleInput!, $first: Int!) {
    people(first: $first, input: $input) {
      nodes {
        id
        pgaId
        latestProgram {
          programType {
            name
          }
          band {
            classification {
              name
              description
            }
          }
        }
      }
    }
  }
`;
